<template>
  <CRow>
    <CCol col="12">
      <CRow>
        <CCol col="10">
          <AppForm 
            vo-name="ProductOrderSearchTermsVo"
            @changed="onSearchTermsChange"
            @init="onSearchTermsChange"
          />
        </CCol>
        <CCol col="2">
          <LoadingStateButton
            @click="onSearchProductOrders"
            :text="i18nMessage.Search"
            color="primary"
            :loading="searchProductOrdersLoading"
          />
        </CCol>
      </CRow>
      <CCard>
        <CCardBody>
          <CDataTable
            outlined
            hover
            striped
            tableFilter
            columnFilter
            sorter
            :fields="productOrdersUiMeta"
            :items="productOrders"
            :items-per-page="20"
            clickable-rows
            :active-page="activePage"
            @row-clicked="rowClicked"
            :pagination="{ align: 'center'}"
            @page-change="pageChange"
            :noItemsView="{ noResults: i18nMessage.NoFilteredResultsAvailable, noItems: i18nMessage.NoItemsAvailable }"
          >
            <template #order_no="{item}">
              <td>
                # {{item.order_no}}
              </td>
            </template>
            <template #member_name="{item}">
              <td>
                {{item.member_name}}
                <a
                  v-on:click.stop=";"
                  target="_blank" 
                  :href="$router.resolve({path: `/member/${item.member_id}`}).href"
                  > <CIcon size="sm" name="cil-external-link" /></a>
              </td>
            </template>
            <template #grand_total="{item}">
              <td>
                $ {{item.grand_total}}
              </td>
            </template>
            <template #updated_at="{item}">
              <td>
                {{item.updated_at ? new Date(item.updated_at).format('yyyy-MM-dd hh:mm:ss') : ''}}
              </td>
            </template>
            <template #created_at="{item}">
              <td>
                {{item.created_at ? new Date(item.created_at).format('yyyy-MM-dd hh:mm:ss') : ''}}
              </td>
            </template>
          </CDataTable>
          <div style="text-align: center; color: #4f5d73">{{i18nMessage.TotalRows}}: {{productOrders.length}}</div>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import { mapState, mapActions, mapMutations, } from 'vuex'
import AppForm from '../../components/AppForm'
import LoadingStateButton from '../../components/LoadingStateButton'

export default {
  name: 'ProductOrders',
  data () {
    return {
      activePage: 1,
      searchTerms: {},
      searchProductOrdersLoading: false,
    }
  },
  components: {
    AppForm,
    LoadingStateButton,
  },
  computed: {
    ...mapState({
      i18nMessage: state => state.i18nMessage,
      productOrders: state => state.product.productOrders,
      productOrdersUiMeta: state => state.product.productOrdersUiMeta,
    }),
  },
  methods: {
    ...mapActions({
      listProductOrders: 'product/listProductOrders',
    }),
    ...mapMutations({
      setProductOrders: 'product/setProductOrders',
    }),
    rowClicked (item) {
      this.$router.push({path: `product-order/${item.id}`})
    },
    pageChange (val) {
      this.$router.push({ query: { page: val }})
    },
    onSearchTermsChange(data) {
      this.searchTerms = data
    },
    onSearchProductOrders () {
      this.searchProductOrdersLoading = true
      this.setProductOrders([])
      this.listProductOrders({
        status: this.searchTerms.search_term_status,
        id: this.searchTerms.search_term_id,
        memberId: this.searchTerms.search_term_member_id,
      }).then(() => {
        this.searchProductOrdersLoading = false
      })
    }
  },
  created () {
  },
  mounted () {
  },
  destroyed () {
    this.setProductOrders([])
  },
  watch: {
    $route: {
      immediate: true,
      handler (route) {
        if (route.query && route.query.page) {
          this.activePage = Number(route.query.page)
        }
      }
    }
  },
}
</script>
